import { defineMessages } from "react-intl";

import {
	complicationsTypeMessages,
	devicesTypeMessages,
	mcsMessages,
	validator
} from "lib/build/forms/htx/current-cardiological-state/heartAssistSystemTherapy";

import { FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	heartAssistSystemTherapy: {
		id: "form.heart_assist_system_therapy",
		defaultMessage: "Mechanikus keringéstámogatás"
	},
	mcs: {
		id: "form.heart_assist_system_therapy.mcs",
		defaultMessage: "MCS?"
	},
	devices: {
		id: "form.heart_assist_system_therapy.devices",
		defaultMessage: "Keringéstámogató eszközök"
	},
	deviceType: {
		id: "form.heart_assist_system_therapy.device_type",
		defaultMessage: "Eszköz típusa"
	},
	deviceName: {
		id: "form.heart_assist_system_therapy.device_name",
		defaultMessage: "Eszköz neve"
	},
	complications: {
		id: "form.heart_assist_system_therapy.complications",
		defaultMessage: "Szövődmények"
	},
	complicationType: {
		id: "form.heart_assist_system_therapy.complication_type",
		defaultMessage: "Típus"
	},
	complicationDate: {
		id: "form.heart_assist_system_therapy.complication_date",
		defaultMessage: "Dátum"
	}
});

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["mcs"],
						label: messages.mcs,
						errorMessages: genericErrorMessages,
						input: {
							type: "button-group",
							props: { labels: mcsMessages }
						}
					}
				}
			]
		},
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field-group-list",
						path: ["devices"],
						label: messages.devices,
						rows: [
							{
								columns: [
									{
										width: 6,
										field: {
											type: "field",
											path: ["type"],
											label: messages.deviceType,
											errorMessages: genericErrorMessages,
											input: {
												type: "select",
												props: {
													labels: devicesTypeMessages
												}
											}
										}
									},
									{
										width: 6,
										field: {
											type: "field",
											path: ["name"],
											label: messages.deviceName,
											errorMessages: genericErrorMessages,
											input: {
												type: "input",
												props: { type: "text" }
											}
										}
									}
								]
							},
							{
								columns: [
									{
										width: 12,
										field: {
											type: "field-group-list",
											path: ["complications"],
											label: messages.complications,
											rows: [
												{
													columns: [
														{
															width: 6,
															field: {
																type: "field",
																path: ["type"],
																label: messages.complicationType,
																errorMessages:
																	genericErrorMessages,
																input: {
																	type: "select",
																	props: {
																		labels: complicationsTypeMessages
																	}
																}
															}
														},
														{
															width: 6,
															field: {
																type: "field",
																path: ["date"],
																label: messages.complicationDate,
																errorMessages:
																	genericErrorMessages,
																input: {
																	type: "input",
																	props: {
																		type: "date"
																	}
																}
															}
														}
													]
												}
											]
										}
									}
								]
							}
						]
					}
				}
			]
		}
	]
};

export const node: LeafNode = {
	id: "heartAssistSystemTherapy",
	value: {
		title: messages.heartAssistSystemTherapy,
		validator,
		fieldset,
		isImportant: true
	}
};
